<script>
    import { onMount } from "svelte";

    let alumni = [
        {
            name: "Johannes Schneider",
            graduationYear: 2022,
            position: "Former President 2021-2022",
            imageUrl: "/assets/alumni/johannes.jpeg",
            description:
                "Johannes is a software engineer at Optiver in Chicago, working on th backend automated trading risk and core systems.",
            tags: ["AI", "Cybersecurity", "Leadership"],
            currentPosition: "Software Engineer",
        },
        {
            name: "Rohan Awasthi",
            graduationYear: 2024,
            position: "Secretary",
            imageUrl: "/assets/alumni/rohan.jpg",
            description:
                "Rohan is a former Secretary for ACM who played a key role in organizing events and fostering community engagement within the club. He is now a Backend Software Engineer, specializing in building robust systems that integrate data and AI technologies. With a strong foundation in backend development and a keen interest in analytics, Rohan focuses on creating scalable solutions that leverage the power of artificial intelligence.",
            tags: ["Backend Developer", "Data and Analytics", "AI Integration"],
            currentPosition: "Software Engineer",
        },
        {
            name: "Azwa Bajwah",
            graduationYear: 2026,
            position: "Former Treasurer",
            imageUrl: "/assets/alumni/azwa.jpg",
            description:
                "Azwa is interested in the research and application of statistical and ML methods in computational biology and computer vision. At ACM, she led funding and finances as treasurer. She plans to continue her education in computer science and mathematics.",
            tags: ["Former Treasurer", "Software Engineering"],
            currentPosition: "Student at University of Maryland",
        },
        {
            name: "Ashan Panduwawala",
            graduationYear: 2020,
            position: "Former Vice President",
            imageUrl: "/assets/alumni/ashan.jpg",
            description:
                "Hi, I'm Ashan! As a Software Engineer at Amazon, I've built a variety of systems ranging from Amazon Games' checkout system to hiring platforms that handle 3 million+ employees.",
            tags: [
                "Former Vice President",
                "Fullstack Engineer",
                "Software Engineering",
            ],
            currentPosition: "Software Development Engineer II at Amazon",
        },
        {
            name: "Pete Smith", // Replace with full name if available
            graduationYear: 2025,
            position: "Member",
            imageUrl: "/assets/alumni/pete.jpg", // Update filename if needed
            description:
                "Pete has a multidisciplinary background and is passionate about using computing resources in support of digital humanities research. Pete's primary technical interests include data engineering and data analysis, with a focus on graph networks that model complex relationships between data.",
            tags: ["Data Engineering", "Former Member"],
            currentPosition:
                "Grad Student at UMD (History & Library Science M.A.)",
        },
        {
            name: "Kevin Hyekang Joo",
            graduationYear: 2023, // latest degree year (MS)
            position: "Former President, Vice President, and Secretary",
            imageUrl: "/assets/alumni/kevin.jpg", // Adjust filename if needed
            description:
                "Kevin Hyekang Joo is a Ph.D. student in Computer Science at USC and an AI researcher at the USC Institute for Creative Technologies. His work focuses on human communication, affective computing, and multimodal video understanding. He's happy to offer advice on AI research or Ph.D. programs — reach out at khjoo@usc.edu!",
            tags: [
                "Former President"
            ],
            currentPosition:
                "Ph.D. Student at the USC",
        },
        {
            name: "Arjun Aggarwal",
            graduationYear: 2025,
            position: "General Member",
            imageUrl: "/assets/alumni/arjun.png",
            description:
                "Focused on building high‑throughput data pipelines and information‑retrieval systems that bridge classroom content and production‑grade software. He will join Google in August 2025 as a Software Engineer within the YouTube product area.",
            tags: ["Software Engineering", "Former Member"],
            currentPosition: "Software Engineer at Google",
        },
        {
            name: "Krishan Panduwawala",
            graduationYear: 2020,
            position: "Vice Chair",
            imageUrl: "/assets/alumni/krishan.png",
            description:
                "Hi! I'm Krishan and I studied CS back in the day and now work as a engineer at Amazon (Game Studios) over in Seattle.",
            tags: ["AWS", "Full Stack", "Game Development"],
            currentPosition: "Software Development Engineer II at Amazon",
        },
    ];

    let searchQuery = "";
    let selectedYear = "all";
    let selectedTag = "all";

    $: uniqueYears = [
        ...new Set(alumni.map((person) => person.graduationYear)),
    ].sort((a, b) => a - b);
    $: uniqueTags = [
        ...new Set(alumni.flatMap((person) => person.tags)),
    ].sort();

    $: filteredAlumni = alumni
        .filter((person) => {
            const matchesSearch =
                person.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                person.currentPosition
                    .toLowerCase()
                    .includes(searchQuery.toLowerCase()) ||
                person.description
                    .toLowerCase()
                    .includes(searchQuery.toLowerCase());

            const matchesYear =
                selectedYear === "all" ||
                person.graduationYear === parseInt(selectedYear);

            const matchesTag =
                selectedTag === "all" || person.tags.includes(selectedTag);

            return matchesSearch && matchesYear && matchesTag;
        })
        .sort((a, b) => a.name.localeCompare(b.name));
</script>

<div class="alumni-container">
    <div class="alumni-header">
        <h1>ACM UMD Alumni</h1>
        <p>
            Meet our distinguished alumni who have gone on to make significant
            contributions in the tech industry
        </p>
    </div>

    <div class="search-container">
        <input
            type="text"
            bind:value={searchQuery}
            placeholder="Search alumni..."
            class="search-input"
        />
        <select bind:value={selectedYear} class="filter-select">
            <option value="all">All Years</option>
            {#each uniqueYears as year}
                <option value={year}>Class of {year}</option>
            {/each}
        </select>
        <select bind:value={selectedTag} class="filter-select">
            <option value="all">All Tags</option>
            {#each uniqueTags as tag}
                <option value={tag}>{tag}</option>
            {/each}
        </select>
    </div>

    {#if filteredAlumni.length === 0}
        <div class="no-results">
            <h3>No alumni found matching your criteria</h3>
            <p>Try adjusting your search or filters</p>
        </div>
    {:else}
        <div class="alumni-grid">
            {#each filteredAlumni as person}
                <div class="alumni-card">
                    <img
                        src={person.imageUrl}
                        alt={person.name}
                        class="alumni-image"
                        loading="lazy"
                        decoding="async"
                    />
                    <h2 class="alumni-name">{person.name}</h2>
                    <p class="alumni-position">{person.currentPosition}</p>
                    <p class="alumni-year">Class of {person.graduationYear}</p>
                    <p class="alumni-description">{person.description}</p>
                    <div class="tag-container">
                        {#each person.tags as tag}
                            <span class="tag">{tag}</span>
                        {/each}
                    </div>
                </div>
            {/each}
        </div>
    {/if}
</div>

<style>
    .alumni-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 2rem;
        background: linear-gradient(135deg, #1a1a1a, #333333);
        min-height: 100vh;
        color: white;
    }

    .alumni-header {
        text-align: center;
        margin-bottom: 2rem;
        color: #ff4433;
        animation: fadeIn 1s ease-in;
    }

    .alumni-header h1 {
        font-size: 2.5rem;
        margin-bottom: 1rem;
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    }

    .alumni-header p {
        font-size: 1.2rem;
        color: #e0e0e0;
        max-width: 800px;
        margin: 0 auto;
    }

    .alumni-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
        gap: 2rem;
        width: 100%;
        max-width: 1200px;
        padding: 1rem;
    }

    .alumni-card {
        background: rgba(255, 255, 255, 0.1);
        border-radius: 15px;
        padding: 1.5rem;
        transition: all 0.3s ease;
        color: white;
        backdrop-filter: blur(10px);
        border: 1px solid rgba(255, 255, 255, 0.1);
    }

    .alumni-card:hover {
        transform: translateY(-5px);
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
        border-color: rgba(255, 68, 51, 0.3);
    }

    .alumni-image {
        width: 120px;
        height: 120px;
        border-radius: 50%;
        object-fit: cover;
        margin: 0 auto 1rem;
        display: block;
        border: 3px solid #ff4433;
    }

    .alumni-name {
        font-size: 1.5rem;
        margin-bottom: 0.5rem;
        color: #ff4433;
        text-align: center;
    }

    .alumni-position {
        font-size: 1.1rem;
        margin-bottom: 0.5rem;
        color: #ffd520;
        text-align: center;
    }

    .alumni-year {
        font-size: 0.9rem;
        color: #888;
        margin-bottom: 1rem;
        text-align: center;
    }

    .alumni-description {
        font-size: 0.9rem;
        line-height: 1.5;
        margin-bottom: 1rem;
        color: #e0e0e0;
    }

    .tag-container {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;
        margin-top: 1rem;
        justify-content: center;
    }

    .tag {
        background: rgba(255, 68, 51, 0.2);
        color: #ff4433;
        padding: 0.25rem 0.75rem;
        border-radius: 15px;
        font-size: 0.8rem;
        transition: all 0.3s ease;
    }

    .tag:hover {
        background: rgba(255, 68, 51, 0.3);
        transform: scale(1.05);
    }

    .search-container {
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;
        justify-content: center;
        margin-bottom: 2rem;
        width: 100%;
        max-width: 800px;
        animation: fadeIn 1s ease-in;
    }

    .search-input {
        padding: 0.75rem 1.25rem;
        border: none;
        border-radius: 25px;
        background: rgba(255, 255, 255, 0.1);
        color: white;
        width: 100%;
        max-width: 300px;
        transition: all 0.3s ease;
    }

    .search-input:focus {
        outline: none;
        background: rgba(255, 255, 255, 0.15);
        box-shadow: 0 0 10px rgba(255, 68, 51, 0.2);
    }

    .filter-select {
        padding: 0.75rem 1.25rem;
        border: none;
        border-radius: 25px;
        background: rgba(255, 255, 255, 0.1);
        color: white;
        cursor: pointer;
        transition: all 0.3s ease;
    }

    .filter-select:focus {
        outline: none;
        background: rgba(255, 255, 255, 0.15);
        box-shadow: 0 0 10px rgba(255, 68, 51, 0.2);
    }

    .filter-select option {
        background: #333;
        color: white;
    }

    .no-results {
        text-align: center;
        color: #ff4433;
        margin: 2rem 0;
        animation: fadeIn 1s ease-in;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @media (max-width: 600px) {
        .alumni-grid {
            grid-template-columns: 1fr;
        }

        .alumni-container {
            padding: 1rem;
        }

        .alumni-header h1 {
            font-size: 2rem;
        }

        .alumni-header p {
            font-size: 1rem;
        }

        .search-container {
            flex-direction: column;
            align-items: center;
        }

        .search-input,
        .filter-select {
            width: 100%;
            max-width: none;
        }
    }
</style>
